<template>
  
  <v-container>

    <div class="content-wrapper">
      <RecommendFund :fund-id="5018" />
    </div>

    <div class="content-wrapper">
      <FundNewer />
    </div>

    <div class="content-wrapper">
      <RecruitFunds />
    </div>

    <div class="mb-4">
      <FundNews />
    </div>

  </v-container>

</template>

<script>
import RecommendFund from '../components/RecommendFund.vue'
import RecruitFunds from '../components/RecruitFunds.vue'
import FundNewer from '../components/FundNewer.vue'
import FundNews from '../components/FundNews.vue'

export default {
  name: 'TabFunds',
  components: {
    RecommendFund,
    RecruitFunds,
    FundNewer,
    FundNews
  },
  data: () => ({
    condition: '',
  }),
  // コンポーネントマウントリスナ
  async mounted() {
  },
  methods: {},
  mixins: []
}
</script>